import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, computed } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import DatePicker from "@/components/ui/DatePicker.vue";
  import dayjs from "dayjs";
  import EoiApi from "@/services/api/eoiApi";
  import { useToast } from "vue-toastification";
  import store from "@/store";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EOIApprovalModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    lot: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "confirm", "loading"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const toast = useToast();
  const props = __props;

  const form = reactive({
    settlementDate: "",
    settlementDiscount: "",
    financeTerms: "",
    contractPreparationFeeDate: "",
    isBuildContractRequired: false,
  });

  const errors = reactive({
    settlementDate: "",
    settlementDiscount: "",
    financeTerms: "",
    contractPreparationFeeDate: "",
  });

  const disabled = ref(false);

  const maxSettlementDate = computed(() => {
    return dayjs().add(10, "year").format("YYYY-MM-DD");
  });

  const isFormValid = computed(() => {
    return !hasErrors();
  });

  function hasErrors(): boolean {
    return Object.values(errors).some((error) => error !== "");
  }

  function validateForm(): boolean {
    Object.keys(errors).forEach((key) => {
      errors[key as keyof typeof errors] = "";
    });

    let isValid = true;

    if (form.settlementDiscount && parseFloat(form.settlementDiscount) < 0) {
      errors.settlementDiscount = "Discount amount cannot be negative";
      isValid = false;
    }

    return isValid;
  }

  function close() {
    form.settlementDate = "";
    form.settlementDiscount = "";
    form.financeTerms = "";
    form.contractPreparationFeeDate = "";
    form.isBuildContractRequired = false;

    Object.keys(errors).forEach((key) => {
      errors[key as keyof typeof errors] = "";
    });

    emits("close");
  }

  function handleSubmit() {
    if (!validateForm()) {
      return;
    }

    disabled.value = true;

    const formData = {
      settlementDate: form.settlementDate,
      settlementDiscount: form.settlementDiscount
        ? parseFloat(form.settlementDiscount)
        : null,
      financeTerms: form.financeTerms,
      contractPreparationFeeDate: form.contractPreparationFeeDate,
      isBuildContractRequired: form.isBuildContractRequired,
    };

    emits("loading");

    EoiApi.updateEoi(props.lot.eoiId as string, formData).catch((error) => {
      toast.error("Failed to update EOI. Please try again.");
      throw new Error(`Error updating EOI: ${error}`);
    });

    store
      .dispatch("eoi/approveEoi", {
        eoiId: props.lot?.eoiId,
        lotId: props.lot?.lotId,
      })
      .then(() => {
        store.dispatch("eoi/getEoiCounter", store.state.user.selectedEstateId);
        emits("confirm");
      })
      .catch((error) => {
        if (error.response.status === 409) {
          emits("confirm");
          toast.error("The action has already been performed.");
        } else {
          toast.error("Something went wrong");
          disabled.value = false;
        }
      });
  }

const __returned__ = { emits, toast, props, form, errors, disabled, maxSettlementDate, isFormValid, hasErrors, validateForm, close, handleSubmit, reactive, ref, computed, Modal, DatePicker, get dayjs() { return dayjs }, get EoiApi() { return EoiApi }, get useToast() { return useToast }, get store() { return store } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})